import React from 'react';

import {LOCATION_LIST_URL} from 'config/urls';

import Link from 'components/Link';

import './styles.css';

const PageNotFound = () => (
  <div className="PageNotFound">
    <div className="mainContent">
      <h1 className="colab-heading">Page not found</h1>
      <Link blue to={LOCATION_LIST_URL}>
        Go back to Locations Dashboard →
      </Link>
    </div>
  </div>
);

export default PageNotFound;
